import { render, staticRenderFns } from "./1039.vue?vue&type=template&id=1bdf45bd&scoped=true&"
import script from "./1039.vue?vue&type=script&lang=js&"
export * from "./1039.vue?vue&type=script&lang=js&"
import style0 from "./1039.vue?vue&type=style&index=0&id=1bdf45bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf45bd",
  null
  
)

export default component.exports